import styled from 'styled-components';

export const NavbarContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${({ theme }) => `0 ${theme.padding.edge}`};
	min-height: 5rem;
	background-color: #fff;
	box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
	margin-bottom: 1rem;
`;

export const Logo = styled.img`
	height: 4rem;
`;

export const CurrentPageTitle = styled.h1`
	font-size: clamp(1.5rem, 2.5vw, 2rem);
	text-transform: uppercase;
	font-weight: bold;
	color: ${({ theme }) => theme.color.primary};
`;
